var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlask = function SvgFlask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 614 449"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#flask_svg__a)",
    stroke: "url(#flask_svg__b)",
    strokeWidth: 0.902,
    d: "M87.99 150.46c-4.49 55.447 8.514 112.757 40.916 163.166 78.504 122.131 241.15 157.497 363.281 78.993 122.13-78.504 157.496-241.151 78.992-363.281q-.722-1.122-1.453-2.236L548.13 106.04l-.273.998-.545-.879-41.591-67.013-22.138 41.067-.377.697-.407-.68-5.876-9.792-13.981 65.246-.224 1.041-.592-.885-29.381-43.858-18.149 24.2-.397.53-.347-.564L343.351 1.921 315.563 143l-.224 1.135-.604-.986-16.22-26.493-30.518 33.357-.355.388-.329-.411-72.22-90.096-63.672 109.457-.203.35-.37-.164z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#flask_svg__c)",
    stroke: "url(#flask_svg__d)",
    strokeWidth: 0.902,
    d: "m562.005 156.68-21.9-22.607-3.519 27.443-.05.394h-13.822l-4.315 34.525-.102.815-.633-.523-87.539-72.347-21.229 56.951-.196.525-.472-.304-65.081-42.014-16.341 28.597-.336.587-.413-.536-4.596-5.961-23.686 34.41-.505.734-.293-.842-46.096-132.811-95.655 163.273-.585.998-.245-1.13-18.723-86.289-19.367 55.959-.315.91-.498-.825-27.542-45.665c-2.67 33.752 1.141 68.183 11.863 101.319a4.094 4.094 0 0 1-1.67 4.707l-60.076 38.616a4.06 4.06 0 0 1-5.61-1.219l-2.605-4.053a3.157 3.157 0 0 0-4.364-.949L3.87 303.265a3.157 3.157 0 0 0-.948 4.363l79.127 123.099a3.157 3.157 0 0 0 4.363.949l21.62-13.897a3.16 3.16 0 0 0 .949-4.363l-2.606-4.053a4.06 4.06 0 0 1 1.22-5.61l60.077-38.617a4.1 4.1 0 0 1 4.978.439c85.883 78.596 216.992 92.958 319.538 27.044 122.13-78.504 157.496-241.151 78.992-363.281q-.615-.956-1.235-1.904l-7.165 128.957-.057 1.03z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#flask_svg__paint4_linear_2453_167)",
    d: "M335.421 286.435c63.942-34.263 184.018-54.812 236.063-60.804-16.029 22.458-48.523 67.523-50.26 68.116-2.171.742-59.189 41.077-64.103 43.726-3.931 2.119-97.858 19.212-144.329 27.494l-120.459-40.309c21.053 1.535 79.146-3.96 143.088-38.223"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#flask_svg__paint5_linear_2453_167)",
    fillRule: "evenodd",
    d: "M191.473 324.702c58.518 61.473 149.574 86.915 235.154 57.673 74.335-25.4 126.691-85.958 144.844-156.764-24.38 24.161-68.371 61.713-106.803 74.845-21.969 7.506-56.545 6.229-95.796 4.779-57.404-2.12-124.808-4.609-177.399 19.467",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#flask_svg__e)",
    fillRule: "evenodd",
    d: "m569.27 35.018-2.456 125.976-26.931-27.746-.277 28.168h-17.219l-1.258 37.61-91.205-75.399-18.614 59.31-68.363-44.014-14.363 31.9-7.16-9.334-23.247 37.082-47.215-135.943-94.886 169.554-20.273-92.982-18.887 59.401-21.127-34.925c-.037 31.124 5.635 62.493 17.371 92.48a2.73 2.73 0 0 1-1.057 3.289l-74.357 47.796a2.707 2.707 0 0 1-3.74-.813l-5.325-8.283a2.706 2.706 0 0 0-3.74-.814l-14.007 9.004a2.706 2.706 0 0 0-.813 3.74l72.777 113.221a2.707 2.707 0 0 0 3.74.813l14.007-9.004a2.707 2.707 0 0 0 .813-3.74l-6.685-10.4a2.706 2.706 0 0 1 .813-3.74l76.362-49.085a2.73 2.73 0 0 1 3.351.325c82.97 78.608 211.757 93.691 312.204 29.125 115.216-74.06 150.583-225.556 81.767-342.572",
    clipRule: "evenodd",
    opacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#300B40",
    fillRule: "evenodd",
    d: "M289.413 399.181a261.4 261.4 0 0 0 44.699 3.833c138.171 0 251.135-107.927 259.187-244.076q.457 7.356.459 14.828c0 130.119-105.482 235.601-235.602 235.601-23.913 0-46.995-3.562-68.743-10.186",
    clipRule: "evenodd",
    opacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "flask_svg__a",
    x1: 288.744,
    x2: 350.042,
    y1: -321.834,
    y2: 181.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#491D5B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491D5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "flask_svg__b",
    x1: 350.042,
    x2: 350.042,
    y1: 0.705,
    y2: 434.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76398E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76398E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "flask_svg__c",
    x1: 306.998,
    x2: 282.697,
    y1: 55.675,
    y2: 300.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#974FB4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#974FB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "flask_svg__d",
    x1: 306.998,
    x2: 306.998,
    y1: 26.045,
    y2: 434.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7A1FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "flask_svg__e",
    x1: 306.475,
    x2: 306.475,
    y1: 35.018,
    y2: 425.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D23A1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D23A1"
  })))));
};
export default SvgFlask;